module.exports = {"@metadata":{"authors":["Saraiki"]},"app-feedback-link":"مدد","error":"خرابی","error-help":"$1، تے ول $2۔","field-label-end-date":"ختم کرݨ دی تریخ","field-label-start-date":"شروع کرݨ دی تریخ","field-label-users":"ورتݨ آلے","field-label-wiki":"وکی","field-select-placeholder":"چُݨو۔۔۔","field-select-search-prompt":"ڳولݨ کیتے لکھو","view-source-code-on":"$1 تے ݙیکھو","warning-no-results":"کوئی نتیجہ کائنی۔","discuss-on-wiki-copy":"نقل کرو","discuss-on-wiki-copied":"نقل تھی ڳئے!"}


//////////////////
// WEBPACK FOOTER
// ../i18n/skr-arab.json
// module id = 319
// module chunks = 0